<template>
  <div class="home">
    <div class="noticecontainer" id="noticecontainer">
      <Notice></Notice>
    </div>
    <!-- <div class="specialcontainer" id="specialcontainer">
      <Special></Special>
    </div> -->
    <!-- <div class="videocontainer" id="videocontainer">
      <Videocon></Videocon>
    </div> -->
    <!-- <div class="articlecontainer" id="articlecontainer">
      <Article></Article>
    </div> -->
    <!-- <div class="Informationcontainer" id="Informationcontainer">
      <Information></Information>
    </div> -->
   <!-- <div class="foot">
      <Footers />
   </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Notice from "./notice/index.vue";
// import Special from "./special/index.vue";
// import Videocon from "./video/index.vue";
// import Article from "./article/index.vue";
// import Information from "./Information/index.vue";
// import Footers from "@/components/footer/index.vue";
var VueScrollTo = require("vue-scrollto");
import { mapState } from "vuex";
export default {
  name: "Home",
  components: {
    Notice,
    // Special,
    // Videocon,
    // Article,
    // Information,
    // Footers,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["scrollId"]),
    nowscrollId() {
      return this.$store.state.scrollId;
    },
  },
  created() {
    // this.$store.watch(
    //   (state) => {
    //     return state.scrollId;
    //   },
    //   () => {
    //     console.log(this.$store.state.scrollId);
        
    //   }
    // );
  },
  mounted() {},
  methods: {
    scrollfun() {
      VueScrollTo.scrollTo(
        document.getElementById(this.$store.state.scrollId),
        1000,
        {
          offset: -50,
        }
      );
    },
  },
  watch: {
    nowscrollId: function (nl, ol) {
      //此处即可监听到
      console.log(nl, ol)
      this.scrollfun();
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  background-color: #ffffff;
  > div {
    width: 80%;
    // min-height: 600px;
    margin: 0 auto;
  }
  .noticecontainer {
     margin-top: 11vh;
  }
  .specialcontainer {
    margin-top: 21vh;
  }
  .videocontainer {
    width: 100%;
    margin-top: 21vh;
  }
  .articlecontainer {
    margin-top: 21vh;
  }
  .Informationcontainer {
    margin-top: 21vh;
    margin-bottom: 10vh;
  }
  .foot {
    width: 100%;
  }
}
</style>


